import React from 'react';
import ReactDOM from 'react-dom';
import get from 'lodash/get';
import { Provider } from 'react-redux';
import storeBuilder from 'reduxStore/store';
import Wahanda from 'common/wahanda';
import { Initializer } from 'common/types/initializers';
import { CustomerFormDialog } from './container';
import { track } from 'src/tracking/trackingService';

const container = Wahanda.Dialogs.getReactContainer();
const store = storeBuilder();
interface Params {
  id?: number;
  customerData?: object;
  fieldToFocus?: string;
}

function destroy(target) {
  ReactDOM.unmountComponentAtNode(target);
}

const onClose = () => {
  destroy(container);
};
const onSubmit = ({ notes_edited }: { notes_edited: boolean }) => {
  track('clients.client_list.edit_client_modal.edited', {
    notes_edited: notes_edited ? 'true' : 'false',
  });
  onClose();
};

export const CustomerFormDialogInitializer = (params: Params): Initializer => ({
  destroy: () => ReactDOM.unmountComponentAtNode(container),
  render: () => {
    ReactDOM.render(
      <Provider store={store}>
        <CustomerFormDialog
          customerId={get(params, 'id')}
          customerData={get(params, 'customerData')}
          fieldToFocus={get(params, 'fieldToFocus')}
          onClose={onClose}
          onSubmit={onSubmit}
        />
      </Provider>,
      container,
    );
  },
});
